import { Helmet } from 'react-helmet-async';
// @mui
import { Grid,  Container, Stack, Typography, Card, Box, Divider, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useGetUser from '../hooks/useGetUser';
import { auth } from '../firebase';

function UpgradePro() {
  const navigate = useNavigate()
  const user = useGetUser(auth.currentUser?.uid)
  return (
    <>
      <Helmet>
        <title> Upgrade to Pro</title>
      </Helmet>

      <Container>
 

      <Stack spacing={3} justifyContent={"center"} alignItems={"center"}> 
          <Typography variant='h3' sx={{textAlign:"center"}}>Flexible plans <br/>for you
      and your business needs.<br/>
      <Typography component={"span"}>
      Choose your plan and make modern online conversation magic
      </Typography>
      </Typography>
      </Stack>
        
        <Grid container spacing={3} sx={{mt:3}}>
          <Grid item xs={12} md={4}>
          <Card sx={{p:4}}>
          <Box>
            
            <Typography variant='h5'>Free</Typography>
            <Typography variant='overline'>Forever</Typography>
            <br/><br/>
            <Typography variant='h2'>$0.00</Typography>
            <Divider sx={{my:6}} >Features</Divider>
            <Typography variant='body1'>1 Business</Typography><br/>
            <Typography variant='body1'>1 Album</Typography><br/>
            <Typography variant='body1'>10 Images</Typography><br/>
            <Typography variant='body1'>3 items in Marketplace</Typography><br/>
            <Typography variant='body1'>Basic Analytics</Typography>
            <Divider sx={{my:6}} >Select package</Divider>
            {user?.account === "FREE" ? <Typography variant='body1'>Current Package</Typography> : 
            <Button variant="contained" color="success" onClick={()=>navigate("/dashboard/payment", {state : {package : "FREE", bill : 0}})} fullWidth>Choose Free</Button>}
          </Box>
          </Card>
          </Grid>
          <Grid item xs={12} md={4}>
          <Card sx={{p:4}}>
          <Box>
            
            <Typography variant='h5'>Basic</Typography>
            <Typography variant='overline'>Monthly</Typography>
            <br/><br/>
            <Typography variant='h2'>$0.99</Typography>
            <Divider sx={{my:6}} >Features</Divider>
            <Typography variant='body1'>4 Business</Typography><br/>
            <Typography variant='body1'>4 Albums</Typography><br/>
            <Typography variant='body1'>20 Images (per album)</Typography><br/>
            <Typography variant='body1'>10 items in Marketplace</Typography><br/>
            <Typography variant='body1'>Weekly featured Post</Typography><br/>
            <Typography variant='body1'>Limited Analytics</Typography>
            <Divider sx={{my:6}} >Select package</Divider>
            {user?.account === "BASIC" ? <Typography variant='body1'>Current Package</Typography> : 
            <Button variant="contained" color="success"  onClick={()=>navigate("/dashboard/payment", {state :{package : "BASIC", bill : 0.99}})} fullWidth>Choose Basic</Button>}
          </Box>
          </Card>
          </Grid>
          <Grid item xs={12} md={4}>
          <Card sx={{p:4}}>
          <Box>
            
            <Typography variant='h5'>Pro</Typography>
            <Typography variant='overline'>Yearly </Typography>
            <br/><br/>
            <Typography variant='h2'>$40.99</Typography>
            <Divider sx={{my:6}} >Features</Divider>
            <Typography variant='body1'>Unlimited Business</Typography><br/>
            <Typography variant='body1'>Verified Account</Typography><br/>
            <Typography variant='body1'>Unlimited Album</Typography><br/>
            <Typography variant='body1'>50 Images per album</Typography><br/>
            <Typography variant='body1'>Daily featured post</Typography><br/>
            <Typography variant='body1'>Unlimited items in Marketplace</Typography><br/>
            <Typography variant='body1'>Advanced Analytics</Typography>
            <Divider sx={{my:6}} >Select package</Divider>
            {user?.account === "PRO" ? <Typography variant='body1'>Current Package</Typography> : 
            <Button variant="contained" color="success"  onClick={()=>navigate("/dashboard/payment", {state : {package :"PRO", bill : 40.99}})} fullWidth>Choose Pro</Button>}
          </Box>
          </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default UpgradePro